
const EasyBank = () => {
    return (
        <a className="project-link" href="https://github.com/Mikkomannine/EasyBank/tree/main" target="_blank" rel="noopener noreferrer">
            <div className="easybank">
                <div className="project-header">
                    <img src="./images/easybank.jpg" alt="EasyBank" className="project-image" />
                    <h2>EasyBank</h2>
                </div>
            </div>
        </a>
    );
};

export default EasyBank;
